import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Facebook } from "lucide-react";

const FB_URL = "https://www.facebook.com/cka22";
const IG_URL = "https://www.instagram.com/camskooriart";
const IG_HANDLE = "@camskooriart";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0F0F0F] border-t border-white/10 mt-24">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="overline mb-6">Let's create together</p>
            <h2 data-testid="footer-cta-heading" className="font-display text-5xl md:text-7xl leading-none">
              Bring your <span className="text-[#FF4500]">story</span> to life.
            </h2>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/custom" data-testid="footer-cta-request" className="btn-primary">
                Request Custom Work
              </Link>
              <Link to="/shop" data-testid="footer-cta-shop" className="btn-ghost">
                Explore Shop
              </Link>
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-4">Navigate</p>
            <ul className="space-y-2 text-sm">
              <li><Link data-testid="footer-link-shop" to="/shop" className="hover:text-[#FF4500]">Shop</Link></li>
              <li><Link data-testid="footer-link-portfolio" to="/portfolio" className="hover:text-[#FF4500]">Portfolio</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-[#FF4500]">About Cam</Link></li>
              <li><Link data-testid="footer-link-custom" to="/custom" className="hover:text-[#FF4500]">Custom Requests</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-[#FF4500]">Contact</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-4">Support</p>
            <ul className="space-y-2 text-sm">
              <li><Link data-testid="footer-link-faq" to="/faq" className="hover:text-[#FF4500]">FAQs</Link></li>
              <li><Link data-testid="footer-link-shipping" to="/shipping" className="hover:text-[#FF4500]">Shipping & Returns</Link></li>
              <li><Link data-testid="footer-link-contact-support" to="/contact" className="hover:text-[#FF4500]">Contact Support</Link></li>
              <li><Link data-testid="footer-link-admin" to="/admin/login" className="hover:text-[#FF4500]">Admin</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-sm text-white/60">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_indigenous-merch/artifacts/pftx9pi2_downloadfile-6.png"
              alt="CKA emblem"
              className="w-12 h-12 object-contain"
              style={{
                WebkitMaskImage:
                  "radial-gradient(circle at center, black 40%, rgba(0,0,0,0.6) 60%, transparent 82%)",
                maskImage:
                  "radial-gradient(circle at center, black 40%, rgba(0,0,0,0.6) 60%, transparent 82%)",
              }}
            />
            <p>© {new Date().getFullYear()} Cam's Koori Art — All rights reserved.</p>
          </div>
          <div className="flex items-center gap-6 flex-wrap">
            <span className="flex items-center gap-2"><MapPin className="w-4 h-4" /> Australia</span>
            <a href="mailto:hello@camskooriart.com" className="flex items-center gap-2 hover:text-white"><Mail className="w-4 h-4" /> hello@camskooriart.com</a>
            <a
              href={FB_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-facebook"
              className="flex items-center gap-2 hover:text-[#FF4500]"
            >
              <Facebook className="w-4 h-4" /> Facebook
            </a>
            <a href={IG_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex items-center gap-2 hover:text-[#FF4500]"><Instagram className="w-4 h-4" /> {IG_HANDLE}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
